import databus from '../common/databus';
import Base64 from '../common/base64';
import { getScript, setChannelKey, getObjectPath, getItem, openAppByScheme, generateQueryString } from '../common/utils';
export default function ucqqBrowser(share, browser, way, callback) {
    if (browser === 'UC')
        setShareUC(way, callback);
    if (browser === 'QQ') {
        document.getElementById('qqApi') ? setShareQQ(way, callback) : getScript('https://jsapi.qq.com/get?api=app.share', function () {
            window.console.log('have jsapi.qq.com api');
            setShareQQ(way, callback);
        }, { id: 'qqApi' });
    }
    function setShareUC(type, callback) {
        var _a = share[type === 'weixin_moment' ? 'weixin_moment' : type], pics = _a.pics, title = _a.title, desc = _a.desc, link = _a.link;
        var isIos = databus.browser.isIos;
        var _link = setChannelKey(link, type);
        var toApp = getObjectPath(getItem(type), "toApp." + (isIos ? 0 : 1));
        window.console.log('toApp', toApp);
        if (toApp === 'QZone') {
            var scheme = generateQueryString({
                share_id: '1101685683',
                url: Base64.encode(link),
                title: Base64.encode(title),
                description: Base64.encode(desc),
                previewimageUrl: Base64.encode(pics),
                image_url: Base64.encode(pics)
            });
            openAppByScheme(getItem('qzone').scheme + "?" + scheme);
        }
        if (typeof window.ucweb !== 'undefined') {
            window.ucweb.startRequest('shell.page_share', [
                title,
                desc,
                _link,
                toApp,
                '',
                "@" + window.location.host,
                ''
            ]);
        }
        else if (getObjectPath(window, 'ucbrowser.web_shareEX')) {
            window.ucbrowser.web_shareEX(JSON.stringify({
                title: title,
                content: desc,
                sourceUrl: _link,
                imageUrl: pics,
                source: "@" + window.location.host,
                target: toApp
            }));
        }
        else if (getObjectPath(window, 'ucbrowser.web_share')) {
            window.ucbrowser.web_share(title, desc, _link, toApp, '', "@" + window.location.host, '');
        }
        else {
            callback && callback();
        }
    }
    function setShareQQ(type, callback) {
        var _a = share[type === 'weixin_moment' ? 'weixin_moment' : type], link = _a.link, title = _a.title, desc = _a.desc, pics = _a.pics;
        var qqShareConfig = {
            title: title,
            url: setChannelKey(link, type),
            description: desc,
            img_url: pics,
            to_app: getObjectPath(getItem(type), 'toApp.2')
        };
        var browserQqShare = getObjectPath(window.browser, 'app.share');
        var browserQbShare = getObjectPath(window.qb, 'share');
        if (browserQqShare) {
            window.browser.app.share(qqShareConfig);
        }
        else if (browserQbShare) {
            window.qb.share(qqShareConfig);
        }
        else {
            callback && callback();
        }
    }
}
